import { render, staticRenderFns } from "./BillHouseList.vue?vue&type=template&id=ecd46b94&scoped=true"
import script from "./BillHouseList.vue?vue&type=script&lang=js"
export * from "./BillHouseList.vue?vue&type=script&lang=js"
import style0 from "./BillHouseList.vue?vue&type=style&index=0&id=ecd46b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd46b94",
  null
  
)

export default component.exports